const commodity = resolve => require(['@/components/mdse/commodity/index.vue'], resolve);
const com_publishShop = resolve => require(['@/components/mdse/commodity/com_publishShop.vue'], resolve);
const nextEdit = resolve => require(['@/components/mdse/commodity/nextEdit'], resolve)
const storegoods = resolve => require(['@/components/mdse/storegoods/index.vue'], resolve);
const storeDaily = resolve => require(['@/components/mdse/storegoods/storeDaily'], resolve)
const customized = resolve => require(['@/components/mdse/customized/index.vue'], resolve)
const custNextEdit = resolve => require(['@/components/mdse/customized/nextEdit.vue'], resolve)

export default [{
    path: '/homeMain/mdse/commodity',
    component: commodity,
}, {
    path: "/homeMain/mdse/storegoods",
    component: storegoods,
    meta: {
        keepAlive: true
    }
}, {
    path: "/homeMain/mdse/com_publishShop",
    component: com_publishShop
}, {
    path: "/homeMain/mdse/store_daily",
    component: storeDaily
}, {
    path: "/homeMain/mdse/nextEdit",
    component: nextEdit
},{
    path:"/homeMain/mdse/customized",
    component: customized
},{
    path:"/homeMain/mdse/custNextEdit",
    component: custNextEdit
}]


// WEBPACK FOOTER //
// ./src/router/mdse.js